<mat-card appearance="outlined">
    <mat-card-content> 
        
            <mat-card-actions class="action-bar">
                
                <mat-button-toggle-group name="searchTarget" dir="auto" [formControl]="searchTarget" aria-label="Search Target" [hideSingleSelectionIndicator]="true" (change)="onSearchTargetChange()">
                    <mat-button-toggle value="subject">
                        <mat-icon>short_text</mat-icon> Subject
                    </mat-button-toggle>
                    <mat-button-toggle value="body">
                        <mat-icon>subject</mat-icon> Body
                    </mat-button-toggle>
                    <mat-button-toggle value="subjectBody">
                        <mat-icon>short_text</mat-icon><mat-icon>subject</mat-icon> Subject and Body
                    </mat-button-toggle>
                </mat-button-toggle-group>
                    <span class="action-links">
                        <a mat-button mat-stroked-button routerLink="/inbox" class="m-r-05" [matBadge]="unreadMessagesCount" matBadgePosition="before" [matBadgeHidden]="!unreadMessagesCount || unreadMessagesCount === 0"><mat-icon>inbox</mat-icon>Inbox</a>
                        <a mat-button mat-stroked-button routerLink="/sent" class="m-r-05"><mat-icon>outbox</mat-icon> Sent</a>
                        <a mat-button mat-flat-button [routerLink]="getComposeMessageRouterLink()"><mat-icon>add</mat-icon> New Message</a>
                    </span>           
            </mat-card-actions>
      
        <mat-form-field appearance="outline" class="search">
            <mat-label>Search</mat-label>
            <input matInput placeholder="Search" [formControl]="search" (keyup)="onSearchTermChange()"/>
            <mat-icon matSuffix (click)="clearSearch()" *ngIf="search.value" class="cursor-pointer" title="Clear search text">close</mat-icon>
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
<mat-card-actions class="actions-bar">
        <mat-button-toggle-group name="searchFilter" [formControl]="searchFilter" aria-label="Search Filter" [hideSingleSelectionIndicator]="true" class="m-b-1">
            <mat-button-toggle value="hasAttachment" (change)="toggleFilter($event, 'hasAttachment')">
                <mat-icon>attach_file</mat-icon> Attachments
            </mat-button-toggle>
            <mat-button-toggle value="unread" (change)="toggleFilter($event, 'unread')">
                <mat-icon>mark_email_unread</mat-icon> Unread
            </mat-button-toggle>
            <mat-button-toggle value="uneradAttachments" (change)="toggleFilter($event, 'uneradAttachments')">
                <mat-icon>attach_email</mat-icon> Unread Attachments
            </mat-button-toggle>
        </mat-button-toggle-group>
        </mat-card-actions>

        <div class="d-flex justify-content-center" *ngIf="loading">
            <mat-spinner></mat-spinner>
        </div>

        @if (!loading){
            @if (pagedMessages != null) {
                <app-message-list [pagedMessages]="pagedMessages"></app-message-list>
            }
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="pagedMessages?.pageSize ?? defaultPagedRequest.pageSize" [length]="pagedMessages?.totalCount" showFirstLastButtons aria-label="Select page of Messages" 
                (page)="handlePageEvent($event)" [hidden]="pagedMessages?.items?.length === 0" [pageIndex]="(pagedMessages?.pageNumber ?? defaultPagedRequest.pageNumber) - 1"></mat-paginator>
        }
    </mat-card-content>
  </mat-card>

  